import type { HistoryOptions } from "@bloomberg/octagon-client";
import { marketDataClient } from "~config/octagon-client";
import type { ChartType } from "~types/portfolio";
import { HistoryChartData } from "~types/types";
import getChartQueryArgs from "~utils/portfolio/getChartQueryArgs";

const mc = marketDataClient.getInstance();

export const enum Periodicity {
  Daily = "daily",
  Monthly = "monthly",
  Quarterly = "quarterly",
  Weekly = "weekly",
  Yearly = "yearly",
}

export function getChartPeriodicity(chartDateRange: string): Periodicity {
  let periodicity = Periodicity.Daily;

  switch (chartDateRange) {
    case "1M":
    case "6M":
    case "YTD":
    case "1Y":
      periodicity = Periodicity.Daily;
      break;
    case "5Y":
      periodicity = Periodicity.Weekly;
      break;
  }

  return periodicity;
}

export const fetchHistoryChartData = async (
  tickers: Array<string>,
  chartType: ChartType
): Promise<HistoryChartData[]> => {
  try {
    const { startDate, endDate } = getChartQueryArgs(chartType);

    const periodicity = getChartPeriodicity(
      chartType
    ) as unknown as HistoryOptions["periodicity"];

    const historyResponse = await mc.getHistory({
      securities: tickers.join(","),
      startDate,
      endDate,
      periodicity,
      fields: "PX_LAST",
    });

    return historyResponse as unknown as HistoryChartData[];
  } catch (error) {
    window?.newrelic.noticeError?.(error, {
      context: "fetchHistoryChartData",
      tickers,
    });

    throw new Error(
      `Failed to fetch fetchHistoryChartData for ${tickers.join(
        ", "
      )} (${chartType})`
    );
  }
};
